import { render, staticRenderFns } from "./orderMatchDialog.vue?vue&type=template&id=5383dfd3&scoped=true&"
import script from "./orderMatchDialog.vue?vue&type=script&lang=js&"
export * from "./orderMatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderMatchDialog.vue?vue&type=style&index=0&id=5383dfd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383dfd3",
  null
  
)

export default component.exports